$(document).on('click', '.custom-bundle-delete', function(e) {
  e.preventDefault();
  e.stopPropagation();

  const removeUrl = $(this).attr('data-remove-url');
  if (!removeUrl) return;

  // Show your theme loader overlay
  $('.custom--subscription--loader-wrapper').show();
  console.log("🗑️ Removing entire bundle group via background AJAX...");

  // Execute a background POST request to Shopify's update engine using the bundled keys
  $.ajax({
    type: 'POST',
    url: removeUrl,
    dataType: 'json',
    success: function() {
      console.log("✅ Bundle successfully removed from server cache.");
      
      // Fetch a clean copy of the cart to force the layout layers to update
      $.getJSON('/cart.js', function(freshCart) {
        $('.custom--subscription--loader-wrapper').hide();

        // 1. Announce update to standard Shopify component themes (Dawn, etc.)
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { cart: freshCart }
        }));

        // 2. Trigger your theme's specific section drawer redraw hooks
        const cartDrawer = document.querySelector("cart-drawer");
        const drawerItems = document.querySelector("cart-drawer-items");
        
        if (drawerItems && typeof drawerItems.onCartUpdate === "function") {
          drawerItems.onCartUpdate();
        } else if (typeof refreshCartDrawer === "function") {
          refreshCartDrawer();
        }

        // Keep drawer open or re-toggle visibility state smoothly
        if (cartDrawer && typeof cartDrawer.open === "function") {
          cartDrawer.open();
        }
      });
    },
    error: function(err) {
      console.error("❌ Failed to remove bundle items:", err);
      $('.custom--subscription--loader-wrapper').hide();
    }
  });
});
 $('.plan-grid-boxs label.radio-img-block:first').trigger('click')
 $('body').on('click', 'product-info quantity-input.quantity button', function () {
   var getQtypdp = parseInt($('product-info quantity-input.quantity .quantity__input').val());
   console.log(getQtypdp)
   $.getJSON('/cart.js', function (cart) {
     var cartTotal = 0;
     cart.items.forEach(function (item) {
       cartTotal += (item.price * item.quantity);
     });
    cartTotal = cartTotal / 100;
  if (getQtypdp >= 5 || cartTotal > 90) {
         $('product-info .shopify-payment-button').show();
     } else {
         $('product-info .shopify-payment-button').hide();
     }
   });
 });
 $('product-info .shopify-payment-button').hide();
 $.getJSON('/cart.js', function (cart) {
   let freeOfferProduct = null;
    cart.items.forEach(function (item) {
      if (item.product_title.includes("Free Offer")) {
        freeOfferProduct = item.variant_title; // product ka naam
        
        $('.announcement-inner.choose-free-ofefr .itme--dynamic').text(freeOfferProduct)
      }
      });
        console.log(cart.item_count);
        if (cart.item_count > 1) {
        $("ul.chnages--plan-button").show();
         $(".subscription-box-item").show();
        }else{
           $("ul.chnages--plan-button").hide();
           $(".subscription-box-item").hide();
        }
        var totalcarQty = parseInt(cart.item_count);
        var cartTotal = 0;
        
        // Calculate cart total value
        cart.items.forEach(function (item) {
          cartTotal += (item.price * item.quantity);
        });
        
        // Convert cartTotal from cents to dollars
        cartTotal = cartTotal / 100;
        
        $('.cart-count-bubble span[aria-hidden="true"]').text(cart.item_count);
        
        // Enable checkout if either condition is met:
        // 1. At least 5 items, OR
        // 2. Cart total is more than $90
        if (totalcarQty >= 5 || cartTotal > 90) {
       
          $('.cart__dynamic-checkout-buttons.additional-checkout-buttons').css('display','block');
            $("button#CartDrawer-Checkout").removeAttr("disabled", "disabled");
             setTimeout(function() {
             console.log(8895555585)
              
            $('button.cart__checkout-button.button').removeAttr("disabled", "disabled");
             }, 500);
             //$('.cart-error-message-five-qty').hide();
          } else {
            
           
            $('.cart__dynamic-checkout-buttons.additional-checkout-buttons').hide();
            $("button#CartDrawer-Checkout").attr("disabled", "disabled");
            $("button.cart__checkout-button.button").attr("disabled", "disabled");
              console.log(8895556776576575676555585)
             //$('.cart-error-message-five-qty').show();
          }
  

      });
$('body').on('click', 'a#cart-icon-bubble', function () {
  if ($('body').hasClass('product')) {
    const urlParams = new URLSearchParams(window.location.search);
const frequencyVal = urlParams.get("frequency");

if (frequencyVal && frequencyVal.toLowerCase() !== "one-time") {
  $('.subscription-box-details').text('Ships every ' + frequencyVal);
} else {
  $('.subscription-box-details').text(''); // blank
}

    var getProductitle = $('.small-box-bundle-section').attr('data-attr')
// $('.subscription-box-item .subscription-box-title').text(getProductitle)

    $.getJSON('/cart.js', function (cart) {
  if (cart.attributes && cart.attributes.selected_pack) {
    var selectedPack = cart.items?.[0]?.properties?._rc_bundle_parent.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
    console.log('Selected Pack:', selectedPack);
    $('.subscription-box-item .subscription-box-title').text(selectedPack)
  }

        var totalPrice = cart.total_price;
  var totalPriceFormatted = (totalPrice / 100).toFixed(2);
$('.totals__total-value-cart').text('$'+totalPriceFormatted+' USD')
       if (cart.item_count > 1) {
        $("ul.chnages--plan-button").show();
        $(".subscription-box-item").show();
        }else{
           $("ul.chnages--plan-button").hide();
           $(".subscription-box-item").hide();
        }
        if (cart.item_count > 10) {
        $('.free-gift-progress-container').show();
       }else{
         $('.free-gift-progress-container').hide();
       }
      console.log(cart.item_count);
      var totalcarQty = parseInt(cart.item_count);
      var cartTotal = 0;
      var hasSubscription = false;

      // Calculate cart total value
      cart.items.forEach(function (item) {
        cartTotal += (item.price * item.quantity);

        if (item.selling_plan_allocation) {
          hasSubscription = true;
         
        }
      });

      cartTotal = cartTotal / 100;

      // Cart conditions
      $('.cart-count-bubble span[aria-hidden="true"]').text(cart.item_count);
     if (totalcarQty >= 5 || cartTotal > 90) {
  console.log(62376832);
  $('.cart__dynamic-checkout-buttons.additional-checkout-buttons').show();
 // $('.cart-error-message-five-qty').hide();
  $('a.button.custom_checkout-button').removeAttr("disabled",'disabled');
  $("button#checkout").removeAttr("disabled");
  $("button#CartDrawer-Checkout").removeAttr("disabled");
  $('button.cart__checkout-button.button').removeAttr('disabled');
} else {
 
  $('a.button.custom_checkout-button').attr("disabled", "disabled");
  $('.cart__dynamic-checkout-buttons.additional-checkout-buttons').hide();
 // $('.cart-error-message-five-qty').show();
  $("button#CartDrawer-Checkout").attr("disabled", "disabled");
  $("button#checkout").attr("disabled", "disabled");
  $('button.cart__checkout-button.button').attr('disabled', 'disabled');
}


let boxTitle = $('.subscription-box-header .subscription-box-title').text().trim(); // small / large
let maxLimit = 0;

if (boxTitle.includes('signature') || boxTitle.includes('small')) {
  maxLimit = 7;
  // Hide the large box error
  $('.checkout--error-msg-new').hide();
} else if (boxTitle.includes('large')) {
  maxLimit = 11;
  // Hide the small box error
  $('.checkout--error-msg').hide();
}

let current = cart.item_count;

// Select proper error message container based on box type
let errorContainer = maxLimit === 7 ? $('.checkout--error-msg') : $('.checkout--error-msg-new');

// Logic for cart item limits

if (current > maxLimit) {
  let extra = current - maxLimit;
  $('button.cart__checkout-button.button').attr('disabled', 'disabled');
  $('a.button.custom_checkout-button').attr('disabled', 'disabled');
  errorContainer.find('.extra-items-1').text(extra);
 errorContainer.text(`Please remove ${extra} item(s).`).show();

} else if (current < maxLimit) {
  let remaining = maxLimit - current;
  $('button.cart__checkout-button.button').attr('disabled', 'disabled');
  $('a.button.custom_checkout-button').attr('disabled', 'disabled');
  errorContainer.find('.extra-items-1').text(remaining);
  errorContainer.text(`Add ${remaining} more item(s) to ${boxTitle.charAt(0).toUpperCase() + boxTitle.slice(1)}.`).show();
} else {
  // exactly at limit
  $('button.cart__checkout-button.button').removeAttr('disabled');
  $('a.button.custom_checkout-button').removeAttr('disabled');
  errorContainer.hide();
}






     
      if (hasSubscription) {
        
        $('a.button.custom_checkout-button').hide();
        $("button#CartDrawer-Checkout").show();
      } else {
        
        $('a.button.custom_checkout-button').css('display', 'inline-flex');
        $("button#CartDrawer-Checkout").hide();
      }
    });
  } else {
    // if not product page
    $('a.button.custom_checkout-button').removeAttr("disabled");
    $("button#checkout").removeAttr("disabled");
    $("button#CartDrawer-Checkout").removeAttr("disabled");
  }
});




// ---------- Click handler ----------
$('body').on('click', '.choose-you-plan-box', function () {
  $('button#Subscribe').removeAttr('disabled');
  $('input[name="offer_select"]').prop('checked', false);
  $(this).find('input[name="offer_select"]').prop('checked', true);


});









 
// bundelsection js start
function getUrlParameter(name) {
    name = name.replace(/[\[\]]/g, "\\$&");
    const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
    const results = regex.exec(window.location.href);
    if (!results || !results[2]) return null;
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

const frequency = getUrlParameter('frequency');
console.log('URL frequency:', frequency);
$('body').on('click', 'button.bundle-add-btn', function () {
const $planLis = $(this).parents('.bundle-product').find('.selling__plan_id li');

    let matchedSellingId = null;

    $planLis.each(function() {
        const classAttr = $(this).attr('class') || '';
       if (classAttr.toLowerCase().includes(frequency.toLowerCase())) {
            matchedSellingId = $(this).data('selling-id');
            console.log('Match found! data-selling-id:', matchedSellingId);
            return false; 
        }
    });

    if (matchedSellingId) {
       
        $('#selectedSellingId').val(matchedSellingId); 
    } else {
        console.log('Koi matching li nahi mili jiske class me "', frequency, '" ho');
    }
  const $card = $(this).closest('.bundle-product');
  const title = $card.attr('data-title');
  const image = $card.attr('data-image');
  const variantId = $card.attr('data-variant-id');
 // const maxItems = 6;
const maxItems = $('body').hasClass('large-box') ? 10 : 6;

  const $existingItem = $(`ul#bundle-cart-items li[data-variant-id="${variantId}"]`);
  if ($existingItem.length) {
    const $badge = $existingItem.find('.product-item-count');
    let currentQty = parseInt($badge.attr('data-count')) || 1;
    currentQty++;
    $badge.attr('data-count', currentQty);
    $badge.find('.count-number').text(currentQty);
  } else {
const html = `
  <li data-variant-id="${variantId}" 
      data-product-id="${$card.attr('data-product-id') || ''}" 
      data-collection-id="${$card.attr('data-collection-id') || '499029180735'}" 
      class="bundle--box--itesm-list" 
      data-selling-id="${matchedSellingId}">
    <div class="bubdle--box--image">
      <div class="product-item-count" data-count="1">
        <img src="${image}" />
        <span class="count-number">1</span>
      </div>
      <div class="bundle--box-content"><h4>${title}</h4></div>
    </div>
    <div class="delete--icon" data-id="${variantId}">
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
        <path d="M9.07559 3.28801H12.9732C12.9732 2.77116 12.7678 2.27548 12.4024 1.91001C12.0369 1.54455 11.5412 1.33923 11.0244 1.33923C10.5075 1.33923 10.0118 1.54455 9.64637 1.91001C9.2809 2.27548 9.07559 2.77116 9.07559 3.28801ZM7.7764 3.28801C7.7764 2.42659 8.11859 1.60046 8.72771 0.991348C9.33682 0.382235 10.163 0.0400391 11.0244 0.0400391C11.8858 0.0400391 12.7119 0.382235 13.321 0.991348C13.9301 1.60046 14.2723 2.42659 14.2723 3.28801H20.7683C20.9406 3.28801 21.1058 3.35645 21.2276 3.47827C21.3494 3.6001 21.4179 3.76532 21.4179 3.9376C21.4179 4.10989 21.3494 4.27511 21.2276 4.39694C21.1058 4.51876 20.9406 4.5872 20.7683 4.5872H19.3989L17.8477 18.026C17.7381 18.976 17.283 19.8525 16.5691 20.4887C15.8553 21.125 14.9324 21.4766 13.9761 21.4767H8.07261C7.11635 21.4766 6.19348 21.125 5.47961 20.4887C4.76574 19.8525 4.31068 18.976 4.20103 18.026L2.6498 4.5872H1.28045C1.10817 4.5872 0.942944 4.51876 0.821121 4.39694C0.699299 4.27511 0.630859 4.10989 0.630859 3.9376C0.630859 3.76532 0.699299 3.6001 0.821121 3.47827C0.942944 3.35645 1.10817 3.28801 1.28045 3.28801H7.7764ZM5.49112 17.8779C5.56443 18.5111 5.86795 19.0953 6.34394 19.5193C6.81992 19.9433 7.43516 20.1775 8.07261 20.1775H13.9761C14.6136 20.1775 15.2288 19.9433 15.7048 19.5193C16.1808 19.0953 16.4843 18.5111 16.5576 17.8779L18.0907 4.5872H3.95808L5.49112 17.8779ZM9.07559 7.83517C9.24787 7.83517 9.4131 7.90361 9.53492 8.02543C9.65674 8.14725 9.72518 8.31248 9.72518 8.48477V16.2799C9.72518 16.4522 9.65674 16.6174 9.53492 16.7392C9.4131 16.8611 9.24787 16.9295 9.07559 16.9295C8.9033 16.9295 8.73808 16.8611 8.61625 16.7392C8.49443 16.6174 8.42599 16.4522 8.42599 16.2799V8.48477C8.42599 8.31248 8.49443 8.14725 8.61625 8.02543C8.73808 7.90361 8.9033 7.83517 9.07559 7.83517ZM13.6227 8.48477C13.6227 8.31248 13.5543 8.14725 13.4325 8.02543C13.3107 7.90361 13.1454 7.83517 12.9732 7.83517C12.8009 7.83517 12.6356 7.90361 12.5138 8.02543C12.392 8.14725 12.3236 8.31248 12.3236 8.48477V16.2799C12.3236 16.4522 12.392 16.6174 12.5138 16.7392C12.6356 16.8611 12.8009 16.9295 12.9732 16.9295C13.1454 16.9295 13.3107 16.8611 13.4325 16.7392C13.5543 16.6174 13.6227 16.4522 13.6227 16.2799V8.48477Z" fill="#BC2B2B"/>
      </svg>
    </div>
  </li>`;
    $('ul#bundle-cart-items').append(html);
  }


  let totalQty = 0;
  $('ul#bundle-cart-items .count-number').each(function () {
    totalQty += parseInt($(this).text()) || 0;
  });


  $('.total--items-pending-count').text(totalQty);
  const progressPercent = (totalQty / maxItems) * 100;
  $('.bundle-progress-fill').css('width', `${progressPercent}%`);

  if (totalQty >= maxItems) {
   
    $('button.bundle-add-btn').attr('disabled', true).addClass('disabled');
    $('button.bundle-add-btn-quick-view').attr('disabled', true).addClass('disabled');
    
    $('.qty-plus').attr('disabled', true).addClass('disabled');
    $('button#bundle-cart-button').removeAttr('disabled');
   
  } else {
   
    $('button.bundle-add-btn').removeAttr('disabled').removeClass('disabled');
     $('button.bundle-add-btn-quick-view').removeAttr('disabled').removeClass('disabled');
    $('.qty-plus').removeAttr('disabled').removeClass('disabled');
    $('button#bundle-cart-button').attr('disabled', true);
   
  }
   if (totalQty === 10) {
     //$('.feed--meal--people').text('Feeds 2–4 people');
     $('.feed--meal--people').text('');
  }else{
     $('.feed--meal--people').text('');
  }


  $(this).hide();
  $card.find('.bundle--qty-box').show();
  var quickViewval = $(this).parents('.bundle-product').find('.quick-view-product-wrapper input.qty-input').val();
  console.log(quickViewval);
  $card.find('input.qty-input').val(1);
});




// bundle remove button click 
$('body').on('click', 'li.bundle--box--itesm-list .delete--icon', function () {
  const $li = $(this).closest('li.bundle--box--itesm-list');
const variantId = $(this).attr('data-id');
  const removedQty = parseInt($li.find('.count-number').text()) || 0;
  $li.remove();
const $productCard = $(`.bundle-product[data-variant-id="${variantId}"]`);
  if ($productCard.length) {
    $productCard.find('input.qty-input').val(0);
   $productCard.find('.bundle--qty-box').hide();
    $productCard.find('button.bundle-add-btn').show();
  }

  let totalQty = 0;
  $('li.bundle--box--itesm-list .count-number').each(function () {
    totalQty += parseInt($(this).text()) || 0;
   
  });

//  const maxItems = 6;
const maxItems = $('body').hasClass('large-box') ? 12 : 6;
  $('.total--items-pending-count').text(totalQty);
 const progressPercent = (totalQty / maxItems) * 100;
  $('.bundle-progress-fill').css('width', `${progressPercent}%`);

  if (totalQty < maxItems) {
    $('button.bundle-add-btn').removeAttr('disabled').removeClass('disabled');
      $('.bundle-add-btn-quick-view').removeAttr('disabled').removeClass('disabled');
    $('.qty-plus').prop('disabled', false).removeClass('disabled');
    $('button#bundle-cart-button').attr('disabled', 'disabled');
    $('.feed--meal--people').text('');
  }
});


// quantity box click
// Quantity plus
$('body').on('click', '.qty-plus', function () {
  const $input = $(this).siblings('.qty-input');
  let qty = parseInt($input.val()) || 0;

  // Determine maxQty based on body class
  const maxQty = $('body').hasClass('large-box') ? 12 : 6;

  if (qty < maxQty) {
    qty++;
    $input.val(qty);
$('.quick-view-product-wrapper input.qty-input').val(qty)
    // Disable the plus button if it reaches max
    if (qty === maxQty) {
      $(this).prop('disabled', true);
    }
  }
});



// Quantity box

$('body').on('click', '.small-box-bundle-section .quanityt--box', function () {
  const $box = $(this).closest('.bundle--qty-box');
  const $input = $box.find('input.qty-input');
  let qty = parseInt($input.val()) || 0;

  const $productCard = $(this).closest('.bundle-product');
  const variantId = $productCard.attr('data-variant-id');

  // ✅ If qty is 0 → remove cart item
  if (qty === 0) {
    const $li = $(`ul#bundle-cart-items li[data-variant-id="${variantId}"]`);
    if ($li.length) $li.remove();

    // Reset UI
    $productCard.find('.bundle--qty-box').hide();
    $productCard.find('.bundle-add-btn').show();
  }

  // ✅ Else update count in li
  const $targetCount = $(`li.bundle--box--itesm-list[data-variant-id="${variantId}"]`)
    .find('.bubdle--box--image .count-number');
  if ($targetCount.length) {
    $targetCount.text(qty);
  }

  // ✅ Calculate total quantity across all items
  let totalQty = 0;
  $('.bundle--qty-box input.qty-input').each(function () {
    totalQty += parseInt($(this).val()) || 0;
  });

  //const maxItems = 6;
const maxItems = $('body').hasClass('large-box') ? 10 : 6;
  // ✅ Update total count UI
  $('.total--items-pending-count').text(totalQty);

  // ✅ Update progress bar width
  const percent = Math.min((totalQty / maxItems) * 100, 100);
  $('.bundle-progress-fill').css('width', percent + '%');

  // ✅ Optional progress text (if needed)
  // $('.bundle-progress-bar').after(`<div class="bar-text">${totalQty} of ${maxItems} selected</div>`);

  // ✅ Enable/disable buttons based on quantity
  if (totalQty >= maxItems) {
    $('.qty-plus').prop('disabled', true).addClass('disabled');
    $('.bundle-add-btn').prop('disabled', true).addClass('disabled');
     $('.bundle-add-btn-quick-view').prop('disabled', true).addClass('disabled');
    $('button#bundle-cart-button').removeAttr('disabled');
   // $('.feed--meal--people').text('Feed 2–4 people');
  } else {
    $('.qty-plus').prop('disabled', false).removeClass('disabled');
    $('.bundle-add-btn').prop('disabled', false).removeClass('disabled');
     $('.bundle-add-btn-quick-view').prop('disabled', false).removeClass('disabled');
    $('button#bundle-cart-button').attr('disabled', 'disabled');
  //  $('.feed--meal--people').text('');
  }
   if (totalQty === 10) {
     $('.feed--meal--people').text('');
  }else{
     $('.feed--meal--people').text('');
  }
});



$('body').on('click', '.qty-minus', function () {
  const $box = $(this).closest('.bundle--qty-box');
  const $input = $box.find('input.qty-input');
  let qty = parseInt($input.val()) || 0;

  const variantId = $(this).closest('.bundle-product').attr('data-variant-id');

  if (qty > 1) {
    qty--;
    $input.val(qty);

    // ✅ Update count-number inside cart item
    const $targetCount = $(`li.bundle--box--itesm-list[data-variant-id="${variantId}"]`)
      .find('.count-number');
    if ($targetCount.length) {
      $targetCount.text(qty);
      $(this).parents('.bundle-product').find('.quick-view-product-wrapper input.qty-input').val(qty);
    }
  } else {
    // ✅ Quantity becomes 0 — remove cart item
    qty = 0;
    $input.val(0);

    const $li = $(`ul#bundle-cart-items li[data-variant-id="${variantId}"]`);
    if ($li.length) $li.remove();

    // ✅ Reset UI for product card
    const $productCard = $(`.bundle-product[data-variant-id="${variantId}"]`);
    $productCard.find('.bundle--qty-box').hide();
    $productCard.find('.bundle-add-btn').show();
  }

  // ✅ Recalculate total quantity from all inputs
  let totalQty = 0;
  $('.bundle--qty-box input.qty-input').each(function () {
    totalQty += parseInt($(this).val()) || 0;
  });

  // ✅ Update total count
  $('.total--items-pending-count').text(totalQty);

  // ✅ Update progress bar
  //const maxItems = 6;
  const maxItems = $('body').hasClass('large-box') ? 10 : 6;

  const progressPercent = Math.min((totalQty / maxItems) * 100, 100);
  $('.bundle-progress-fill').css('width', `${progressPercent}%`);

  // ✅ Update buttons based on count
  if (totalQty < maxItems) {
    $('.qty-plus').prop('disabled', false).removeClass('disabled');
    $('.bundle-add-btn').prop('disabled', false).removeClass('disabled');
     $('.bundle-add-btn-quick-view').prop('disabled', false).removeClass('disabled');
    $('button#bundle-cart-button').attr('disabled', 'disabled');
    //$('.feed--meal--people').text('');
  } else {
    $('.qty-plus').prop('disabled', true).addClass('disabled');
    $('.bundle-add-btn').prop('disabled', true).addClass('disabled');
      $('.bundle-add-btn-quick-view').prop('disabled', true).addClass('disabled');
    $('button#bundle-cart-button').removeAttr('disabled');
    //$('.feed--meal--people').text('Feed 2–4 people');
  }
     if (totalQty === 10) {
     $('.feed--meal--people').text('');
  }else{
     $('.feed--meal--people').text('');
  }
  
});

let userClicked = false;

// Track if the user clicks manually
$('body').on('mousedown touchstart', '.plan-boxs-items', function () {
  userClicked = true;
});

$('body').on('click', '.plan-boxs-items', function () {
  const dataLink = $(this).attr('data-page-link');
var getPagelink = $(this).find('.plan-option__radio').attr('value');
  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: {
      attributes: {
        "selected_pack": getPagelink
      }
    },
    dataType: 'json',
    success: function(cart) {
      console.log('Cart attribute updated:', getPagelink);
      // optional: update UI
    },
    error: function(err) {
      console.error('Error updating cart attribute', err);
    }
  });
  if (dataLink) {
    $('.frequency-next-btn').attr('href', dataLink);

    // Only scroll if the user actually clicked
    if (userClicked) {

     


var headerHeight = $('.section-header').outerHeight() || 0;
var target = $('.frequency-form')[0].getBoundingClientRect().top + window.pageYOffset;

$('html, body').animate({
  scrollTop: target - headerHeight - 40
}, 400);




      userClicked = false; // reset
    }
  }
 
});


$('.frequency-next-btn').on('click', function(e) {
      e.preventDefault(); 
var frequency = $('input[name="frequency"]:checked').val();
 if (frequency) {
        var baseUrl = $('a.frequency-next-btn').attr('href');
        var fullUrl = baseUrl + "?frequency=" + encodeURIComponent(frequency);
   window.location.href = fullUrl;
      } else {
       // alert("Please select a frequency option.");
      }
    });

// $('body').on('click', 'button#bundle-cart-button', function () {
//   var json_obj = [];

//   function getCookie(name) {
//     const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
//     return match ? decodeURIComponent(match[2]) : null;
//   }

//   // 1. Pehle cart clear karo
//   $.ajax({
//     type: "POST",
//     url: "/cart/clear.js",
//     dataType: "json",
//     success: function () {
//       console.log("Cart cleared");

//       // 2. Gather selected bundle items
//       $('li.bundle--box--itesm-list').each(function () {
//         var variantIdcart = parseInt($(this).attr('data-variant-id'));
//         var variantQty = parseInt($(this).find('.product-item-count .count-number').text());
//         var variantSellingid = parseInt($(this).attr('data-selling-id'));

//         json_obj.push({
//           id: variantIdcart,
//           quantity: variantQty,
//           selling_plan: variantSellingid
//         });
//       });

//       var cookieVariantId = getCookie('selected_variant_id');

//       // 3. Add bundle items to cart
//       $.ajax({
//         type: "POST",
//         url: "/cart/add.js",
//         data: JSON.stringify({ items: json_obj }),
//         dataType: "json",
//         contentType: "application/json",
//         success: function () {
//           // 4. Continue same free gift + finalize flow
//           setTimeout(function () {
//             $.getJSON('/cart.js', function (cart) {
//               const totalQty = cart.items.reduce((sum, item) => sum + item.quantity, 0);
//               const freeOfferItem = cart.items.find(item =>
//                 item.product_title && item.product_title.toLowerCase().includes('free offer')
//               );
//               const hasFreeItem = !!freeOfferItem;

//               if (cookieVariantId && totalQty >= 10 && !hasFreeItem) {
//                 // Add free item
//                 $.ajax({
//                   type: "POST",
//                   url: "/cart/add.js",
//                   data: JSON.stringify({
//                     items: [{
//                       id: parseInt(cookieVariantId, 10),
//                       quantity: 1,
//                       selling_plan: null
//                     }]
//                   }),
//                   contentType: "application/json",
//                   success: function () {
//                     console.log("Free gift added");
//                     finalizeCartUpdate();
//                   }
//                 });
//               } else if (totalQty < 10 && hasFreeItem) {
//                 // Remove free item
//                 $.ajax({
//                   type: "POST",
//                   url: "/cart/change.js",
//                   data: { id: freeOfferItem.key, quantity: 0 },
//                   success: function () {
//                     console.log("Free gift removed");
//                     finalizeCartUpdate();
//                   }
//                 });
//               } else {
//                 finalizeCartUpdate();
//               }
//             });
//           }, 200);
//         },
//         error: function (xhr, status, error) {
//           console.error("Error adding bundle items:", error);
//         }
//       });
//     },
//     error: function (xhr, status, error) {
//       console.error("Error clearing cart:", error);
//     }
//   });

//   // Baaki finalizeCartUpdate & refreshCartDrawer functions same rahenge
//   function finalizeCartUpdate() {
//     $.getJSON('/cart.js', function (cart) {
//       const itemCount = cart.items.reduce((sum, item) => sum + item.quantity, 0);

//       updateFreeGiftProgressBar(itemCount);
//       $('.cart-count-bubble span[aria-hidden="true"]').text(cart.item_count);

//       const cartTotal = cart.items.reduce((sum, item) =>
//         sum + item.price * item.quantity, 0) / 100;

//       if (itemCount >= 5 || cartTotal > 90) {
//         $('.cart__dynamic-checkout-buttons.additional-checkout-buttons').hide();
//         $("button#CartDrawer-Checkout, button#checkout").removeAttr("disabled");
//       } else {
//         $('.cart__dynamic-checkout-buttons.additional-checkout-buttons').show();
//         $("button#CartDrawer-Checkout, button#checkout").attr("disabled", "disabled");
//       }

//       $("cart-drawer").addClass("active");
//       refreshCartDrawer();
//     });
//   }

//   function refreshCartDrawer() {
//     let drawerItems = document.querySelector("cart-drawer-items");
//     const cartDrawer = document.querySelector("cart-drawer");
//     const checkoutBtn = document.querySelector(".cart__checkout-button");

//     if (cartDrawer) {
//       cartDrawer.classList.remove("is-empty");
//       checkoutBtn?.removeAttribute("disabled");

//       const emptyEl = cartDrawer.querySelector(".drawer__inner-empty");
//       emptyEl?.remove();

//       const contentsForm = document.querySelector(".cart__contents");
//       if (contentsForm) contentsForm.style.display = "block";
//     }

//     if (!drawerItems) {
//       drawerItems = document.createElement("cart-drawer-items");
//       const header = document.querySelector(".drawer__header");
//       header?.insertAdjacentElement("afterend", drawerItems);
//     }

//     const itemsComp = document.querySelector("cart-drawer-items");
//     if (typeof itemsComp?.onCartUpdate === "function") {
//       itemsComp.onCartUpdate();
//     }

//     if (typeof cartDrawer?.open === "function") {
//       cartDrawer.open();
//     }
//   }
// });



// $('body').on('click', 'button#bundle-cart-button', function () {
  
//   var json_obj = [];

//   // 1. Gather selected bundle items
//   $('li.bundle--box--itesm-list').each(function () {
//     var variantIdcart = parseInt($(this).attr('data-variant-id'));
//     var variantQty = parseInt($(this).find('.product-item-count .count-number').text());
//     var variantSellingid = parseInt($(this).attr('data-selling-id'));

//     json_obj.push({
//       id: variantIdcart,
//       quantity: variantQty,
//       selling_plan: variantSellingid
//     });
//   });

//   // 2. Add bundle items to cart
//   $.ajax({
//     type: "POST",
//     url: "/cart/add.js",
//     data: JSON.stringify({ items: json_obj }),
//     dataType: "json",
//     contentType: "application/json",
//     success: function () {
//       updateFreeOfferSellingPlan(); // ⬅️ नया step
//       finalizeCartUpdate();
//     },
//     error: function (xhr, status, error) {
//       console.error("Error adding bundle items:", error);
//     }
//   });

//   // ⬇️ नया function (free offer selling_plan update logic)
//   function updateFreeOfferSellingPlan() {
//     // Step 1: URL से frequency value लेना
//     const urlParams = new URLSearchParams(window.location.search);
//     const frequencyVal = urlParams.get("frequency");

//     // Step 2: loop through subscription plans to find matching one
//     let newSellingPlanId = null;
//     if (frequencyVal) {
//       $("ul.offer-subscription-plans li").each(function () {
//         const planName = $(this).data("plan-name");
//         if (planName && planName.toString() === frequencyVal.toString()) {
//           newSellingPlanId = $(this).data("selling-plan-id");
//         }
//       });
//     }

//     // Step 3: get cart and update free offer product
//     $.getJSON("/cart.js", function (cart) {
//       const freeOfferItem = cart.items.find(item => item.properties && item.properties._free_offer);

//       if (freeOfferItem) {
//         $.ajax({
//           type: "POST",
//           url: "/cart/change.js",
//           data: JSON.stringify({
//             id: freeOfferItem.key,                 // line item unique key
//             quantity: freeOfferItem.quantity,
//             selling_plan: newSellingPlanId || ""   // ⬅️ अगर match नहीं हुआ तो blank भेजेंगे
//           }),
//           dataType: "json",
//           contentType: "application/json",
//           success: function () {
//             console.log("Free offer selling plan updated:", newSellingPlanId || "BLANK");
//           },
//           error: function (xhr, status, error) {
//             console.error("Error updating free offer selling plan:", error);
//           }
//         });
//       }
//     });
//   }

//   // Finalize cart update function
//   function finalizeCartUpdate() {
//     $.getJSON('/cart.js', function (cart) {
//       const itemCount = cart.items.reduce((sum, item) => sum + item.quantity, 0);
//       updateFreeGiftProgressBar(itemCount);
//       $('.cart-count-bubble span[aria-hidden="true"]').text(cart.item_count);

//       const cartTotal = cart.items.reduce((sum, item) =>
//         sum + item.price * item.quantity, 0) / 100;

//       if (itemCount >= 5 || cartTotal > 90) {
//         $('.cart__dynamic-checkout-buttons.additional-checkout-buttons').hide();
//         $("button#CartDrawer-Checkout, button#checkout").removeAttr("disabled");
//       } else {
//         $('.cart__dynamic-checkout-buttons.additional-checkout-buttons').show();
//         $("button#CartDrawer-Checkout, button#checkout").attr("disabled", "disabled");
//       }

//       $("cart-drawer").addClass("active");
//       refreshCartDrawer();
//     });
//   }

//   function refreshCartDrawer() {
//     let drawerItems = document.querySelector("cart-drawer-items");
//     const cartDrawer = document.querySelector("cart-drawer");
//     const checkoutBtn = document.querySelector(".cart__checkout-button");

//     if (cartDrawer) {
//       cartDrawer.classList.remove("is-empty");
//       checkoutBtn?.removeAttribute("disabled");

//       const emptyEl = cartDrawer.querySelector(".drawer__inner-empty");
//       emptyEl?.remove();

//       const contentsForm = document.querySelector(".cart__contents");
//       if (contentsForm) contentsForm.style.display = "block";
//     }

//     if (!drawerItems) {
//       drawerItems = document.createElement("cart-drawer-items");
//       const header = document.querySelector(".drawer__header");
//       header?.insertAdjacentElement("afterend", drawerItems);
//     }

//     const itemsComp = document.querySelector("cart-drawer-items");
//     if (typeof itemsComp?.onCartUpdate === "function") {
//       itemsComp.onCartUpdate();
//     }

//     if (typeof cartDrawer?.open === "function") {
//       cartDrawer.open();
//     }
//   }
// });


// $('body').on('click', 'button#bundle-cart-button', function () {
//   $(".custom--subscription--loader-wrapper-packs").show();
//   $('ul.chnages--plan-button').show();
//   $('.subscription-box-item').show();
//   // STEP 1: Clear cart (except free offer)
//   clearCartExceptFreeOffer().then(() => {
//     console.log("✅ Cart cleared (except free offer)");
//     addBundleItems(); // अब safe है bundle add करना
//   });

//   // ========== FUNCTIONS ==========

//   // Function to clear cart except free offer
//   function clearCartExceptFreeOffer() {
//     return new Promise((resolve) => {
//       $.getJSON("/cart.js", function (cart) {
//           var totalPrice = cart.total_price;
//   var totalPriceFormatted = (totalPrice / 100).toFixed(2);
// $('.totals__total-value-cart').text('$'+totalPriceFormatted+' USD')
//         let itemsToRemove = cart.items.filter(item => !(item.properties && item.properties._free_offer));

//         if (itemsToRemove.length === 0) {
//           resolve(); // कुछ remove करने को नहीं
//           return;
//         }

//         let index = 0;

//         function removeNext() {
//           if (index >= itemsToRemove.length) {
//             resolve();
//             return;
//           }

//           let item = itemsToRemove[index];
//           console.log("🗑 Removing:", item.title);

//           $.ajax({
//             type: "POST",
//             url: "/cart/change.js",
//             data: JSON.stringify({ id: item.key, quantity: 0 }),
//             dataType: "json",
//             contentType: "application/json",
//             success: function () {
//               index++;
//               removeNext(); // अगला item हटाओ
//             },
//             error: function (xhr, status, error) {
//               console.error("❌ Error removing item:", error);
//               index++;
//               removeNext(); // error पे भी continue
//             }
//           });
//         }

//         removeNext();
//       });
//     });
//   }

//   // Function: Add Bundle Items
//   function addBundleItems() {
//     var json_obj = [];

//     $('li.bundle--box--itesm-list').each(function () {
//       var variantIdcart = parseInt($(this).attr('data-variant-id'));
//       var variantQty = parseInt($(this).find('.product-item-count .count-number').text());
//       var variantSellingid = parseInt($(this).attr('data-selling-id'));

//       json_obj.push({
//         id: variantIdcart,
//         quantity: variantQty,
//         selling_plan: variantSellingid
//       });
//     });

//     if (json_obj.length === 0) {
//       finalizeCartUpdate();
//       return;
//     }

//     console.log("➕ Adding bundle items:", json_obj);

//     $.ajax({
//       type: "POST",
//       url: "/cart/add.js",
//       data: JSON.stringify({ items: json_obj }),
//       dataType: "json",
//       contentType: "application/json",
//       success: function () {
//         console.log("✅ Bundle items added");
//         updateFreeOfferSellingPlan();
//         finalizeCartUpdate();
//       },
//       error: function (xhr, status, error) {
//         console.error("❌ Error adding bundle items:", error);
//         hideLoader();
//       }
//     });
//   }

//   // Function: Update Free Offer selling plan
//   function updateFreeOfferSellingPlan() {
//     const urlParams = new URLSearchParams(window.location.search);
//     const frequencyVal = urlParams.get("frequency");

//     let newSellingPlanId = null;
//     if (frequencyVal) {
//       $("ul.offer-subscription-plans li").each(function () {
//         const planName = $(this).data("plan-name");
//         if (planName && planName.toString() === frequencyVal.toString()) {
//           newSellingPlanId = $(this).data("selling-plan-id");
//         }
//       });
//     }

//     $.getJSON("/cart.js", function (cart) {
//         var totalPrice = cart.total_price;
//   var totalPriceFormatted = (totalPrice / 100).toFixed(2);
// $('.totals__total-value-cart').text('$'+totalPriceFormatted+' USD')
//       const freeOfferItem = cart.items.find(item => item.properties && item.properties._free_offer);

//       if (freeOfferItem) {
//         $.ajax({
//           type: "POST",
//           url: "/cart/change.js",
//           data: JSON.stringify({
//             id: freeOfferItem.key,
//             quantity: freeOfferItem.quantity,
//             selling_plan: newSellingPlanId || ""
//           }),
//           dataType: "json",
//           contentType: "application/json",
//           success: function () {
//             console.log("✅ Free offer selling plan updated:", newSellingPlanId || "BLANK");
//           },
//           error: function (xhr, status, error) {
//             console.error("❌ Error updating free offer selling plan:", error);
//           }
//         });
//       }
//     });
//   }

//   // Function: Finalize Cart Update
//   function finalizeCartUpdate() {
//     $.getJSON('/cart.js', function (cart) {
//         var totalPrice = cart.total_price;
//   var totalPriceFormatted = (totalPrice / 100).toFixed(2);
// $('.totals__total-value-cart').text('$'+totalPriceFormatted+' USD')
//       const itemCount = cart.items.reduce((sum, item) => sum + item.quantity, 0);
//       updateFreeGiftProgressBar(itemCount);
//       $('.cart-count-bubble span[aria-hidden="true"]').text(cart.item_count);

//       const cartTotal = cart.items.reduce((sum, item) =>
//         sum + item.price * item.quantity, 0) / 100;

//       if (itemCount >= 5 || cartTotal > 90) {
//         $('.cart__dynamic-checkout-buttons.additional-checkout-buttons').hide();
//         $("button#CartDrawer-Checkout, button#checkout").removeAttr("disabled");
//         $('a.button.custom_checkout-button').removeAttr("disabled");
//       } else {
//         $('.cart__dynamic-checkout-buttons.additional-checkout-buttons').show();
//         $("button#CartDrawer-Checkout, button#checkout").attr("disabled", "disabled");
//         $('a.button.custom_checkout-button').attr("disabled");
//       }

//       $("cart-drawer").addClass("active");
//       refreshCartDrawer();
//        hideLoader();
//        if (cart.item_count > 10) {
//         $('.free-gift-progress-container').show();
//        }else{
//          $('.free-gift-progress-container').hide();
//        }
// var getProductitle = $('.small-box-bundle-section').attr('data-attr')
// $('.subscription-box-item .subscription-box-title').text(getProductitle)

//     });
//   }

//   function refreshCartDrawer() {
//     let drawerItems = document.querySelector("cart-drawer-items");
//     const cartDrawer = document.querySelector("cart-drawer");
//     const checkoutBtn = document.querySelector(".cart__checkout-button");

//     if (cartDrawer) {
//       cartDrawer.classList.remove("is-empty");
//       checkoutBtn?.removeAttribute("disabled");

//       const emptyEl = cartDrawer.querySelector(".drawer__inner-empty");
//       emptyEl?.remove();

//       const contentsForm = document.querySelector(".cart__contents");
//       if (contentsForm) contentsForm.style.display = "block";
//     }

//     if (!drawerItems) {
//       drawerItems = document.createElement("cart-drawer-items");
//       const header = document.querySelector(".drawer__header");
//       header?.insertAdjacentElement("afterend", drawerItems);
//     }

//     const itemsComp = document.querySelector("cart-drawer-items");
//     if (typeof itemsComp?.onCartUpdate === "function") {
//       itemsComp.onCartUpdate();
//     }

//     if (typeof cartDrawer?.open === "function") {
//       cartDrawer.open();
//     }
//   }
//   function hideLoader() {
//     $(".custom--subscription--loader-wrapper-packs").hide();
//   }
// });

$('body').on('click', 'button#bundle-cart-button', function () {
  $(".custom--subscription--loader-wrapper-packs").show();
  $('ul.chnages--plan-button').show();
  $('.subscription-box-item').show();
 
  // STEP 1: Clear cart (except product_id 10030172111167)
  clearCartExceptFreeOffer().then(() => {
    console.log("✅ Cart cleared (except product_id 10030172111167)");
    addBundleItems(); // अब safe है bundle add करना
  });

  // ========== FUNCTIONS ==========

  // Function to clear cart except product_id 10030172111167
  function clearCartExceptFreeOffer() {
    return new Promise((resolve) => {
      $.getJSON("/cart.js", function (cart) {
        var totalPrice = cart.total_price;
        var totalPriceFormatted = (totalPrice / 100).toFixed(2);
        $('.totals__total-value-cart').text('$' + totalPriceFormatted + ' USD');

        let itemsToRemove = cart.items.filter(item => item.product_id != 10030172111167);

        if (itemsToRemove.length === 0) {
          resolve();
          return;
        }

        let index = 0;

        function removeNext() {
          if (index >= itemsToRemove.length) {
            resolve();
            return;
          }

          let item = itemsToRemove[index];
          console.log("🗑 Removing:", item.title);

          $.ajax({
            type: "POST",
            url: "/cart/change.js",
            data: JSON.stringify({ id: item.key, quantity: 0 }),
            dataType: "json",
            contentType: "application/json",
            success: function () {
              index++;
              removeNext();
            },
            error: function (xhr, status, error) {
              console.error("❌ Error removing item:", error);
              index++;
              removeNext();
            }
          });
        }

        removeNext();
      });
    });
  }




















function addBundleItems() {
  // 1. Read your parent configuration parameters dynamically
  const isLargeBox = $('body').hasClass('large-box');
  const parentProductId = '9987028484415'; // Change to match your target box product ID if needed
  const parentVariantId = isLargeBox ? '53103258140991' : '53103210889535'; 
  const productHandle = isLargeBox ? 'large-founder-box' : 'small-founder-box';

  // 2. Build the structural dynamic selections array required by Recharge
  let selections = [];

  $('li.bundle--box--itesm-list').each(function () {
    var variantIdcart = parseInt($(this).attr('data-variant-id'), 10);
    var variantQty = parseInt($(this).find('.product-item-count .count-number').text(), 10);
    var variantSellingid = parseInt($(this).attr('data-selling-id'), 10);
    
    // Fallback collection ID attribute. Recharge requires a string identifier here.
    var collectionId = $(this).attr('data-collection-id') || '499029180735'; 

    if (!variantIdcart || variantQty <= 0) return;

    selections.push({
      collectionId: String(collectionId),
      externalProductId: String($(this).attr('data-product-id') || ''), // Ensure data-product-id exists on your LI
      externalVariantId: String(variantIdcart),
      quantity: variantQty,
      sellingPlan: variantSellingid
    });
  });

  if (!selections.length) {
    finalizeCartUpdate();
    return;
  }

  // 3. Package the complete bundle structural payload
  const dynamicBundlePayload = {
    externalProductId: String(parentProductId),
    externalVariantId: String(parentVariantId),
    selections: selections
  };

  console.log('📦 Validating Recharge Bundle Payload:', dynamicBundlePayload);

  // 4. Validate through the SDK engine
  const isValid = recharge.bundle.validateDynamicBundle(dynamicBundlePayload);

  if (isValid !== true) {
    console.error('❌ Recharge Bundle Validation Failed:', isValid);
    alert('Validation error: ' + isValid);
    hideLoader();
    return;
  }

  // 5. Let the SDK map and generate matching properties ('_rc_bundle', '_rc_bundle_parent', etc.)
  const bundledCartItems = recharge.bundle.getDynamicBundleItems(dynamicBundlePayload, productHandle);
  
  console.log('➕ Transformed SDK Cart Array:', bundledCartItems);

  // 6. Post the clean SDK array structure directly to Shopify
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: JSON.stringify({ items: bundledCartItems }),
    contentType: 'application/json',
    dataType: 'json',
    processData: false,
    success: function () {
      console.log('✅ Grouped bundle items added successfully');
      updateFreeOfferSellingPlan();
      finalizeCartUpdate();
    




      
    },
    error: function (xhr) {
      console.log('❌ Error pushing bundle items to Shopify:', xhr.responseJSON || xhr.responseText);
      hideLoader();
    }
  });
}




































  // Function: Update Free Offer selling plan
  function updateFreeOfferSellingPlan() {
    const urlParams = new URLSearchParams(window.location.search);
    const frequencyVal = urlParams.get("frequency");
if (frequencyVal && frequencyVal.toLowerCase() !== "one-time") {
  $('.subscription-box-details').text('Ships every ' + frequencyVal);
} else {
  $('.subscription-box-details').text(''); // blank
}
    let newSellingPlanId = null;

    $("ul.offer-subscription-plans li").each(function () {
      const planName = $(this).data("plan-name");
      if (planName && planName.toString() === frequencyVal?.toString()) {
        newSellingPlanId = $(this).data("selling-plan-id");
      }
    });

    console.log("🎯 Matched Selling Plan ID:", newSellingPlanId);

    $.getJSON("/cart.js", function (cart) {
      var totalPrice = cart.total_price;
      var totalPriceFormatted = (totalPrice / 100).toFixed(2);
      $('.totals__total-value-cart').text('$' + totalPriceFormatted + ' USD');

      const freeOfferItem = cart.items.find(item => item.product_id == 10030172111167);

      if (freeOfferItem) {
       $.ajax({
  type: "POST",
  url: "/cart/change.js",
  data: JSON.stringify({
    id: String(freeOfferItem.key),  // ✅ line item key always string hona chahiye
    quantity: freeOfferItem.quantity,
    selling_plan: newSellingPlanId || "",
    properties: freeOfferItem.properties || {}
  }),
  dataType: "json",
  contentType: "application/json",
  success: function (data) {
    console.log("✅ Free offer selling plan updated:", newSellingPlanId || "BLANK");
    console.log("🔍 Response:", data.items.find(i => i.key === freeOfferItem.key));
    refreshCartDrawer();
  },
  error: function (xhr, status, error) {
    console.error("❌ Error updating free offer selling plan:", error, xhr.responseText);
  }
});

      }
    });
  }

  // Function: Finalize Cart Update
  function finalizeCartUpdate() {
    $.getJSON('/cart.js', function (cart) {
     setTimeout(function () {

    // var selectedPack = cart.attributes.selected_pack;
   var selectedPack = cart.items?.[0]?.properties?._rc_bundle_parent .replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
    $('.subscription-box-item .subscription-box-title').text(selectedPack)
  
}, 200);
      var totalPrice = cart.total_price;
      var totalPriceFormatted = (totalPrice / 100).toFixed(2);
      $('.totals__total-value-cart').text('$' + totalPriceFormatted + ' USD');

      const itemCount = cart.items.reduce((sum, item) => sum + item.quantity, 0);
      updateFreeGiftProgressBar(itemCount);
      $('.cart-count-bubble span[aria-hidden="true"]').text(cart.item_count);

      const cartTotal = cart.items.reduce((sum, item) =>
        sum + item.price * item.quantity, 0) / 100;

      if (itemCount >= 5 || cartTotal > 90) {
        $('.cart__dynamic-checkout-buttons.additional-checkout-buttons').hide();
        $("button#CartDrawer-Checkout, button#checkout").removeAttr("disabled");
        $('a.button.custom_checkout-button').removeAttr("disabled");
        console.log(57754)
      } else {
         console.log(577547547)
        $('.cart__dynamic-checkout-buttons.additional-checkout-buttons').show();
        $("button#CartDrawer-Checkout, button#checkout").attr("disabled", "disabled");
        $('a.button.custom_checkout-button').attr("disabled");
      }
   
// Get the box type from title text




      $("cart-drawer").addClass("active");
      refreshCartDrawer();
      hideLoader();

      if (cart.item_count > 10) {
        $('.free-gift-progress-container').show();
      } else {
        $('.free-gift-progress-container').hide();
      }

      var getProductitle = $('.small-box-bundle-section').attr('data-attr');
      $('.subscription-box-item .subscription-box-title').text(getProductitle);
      
let boxTitle = $('.subscription-box-header .subscription-box-title').text().trim(); // small / large
let maxLimit = 0;

if (boxTitle.includes('signature') || boxTitle.includes('small')) {
  maxLimit = 7;
  // Hide the large box error
  $('.checkout--error-msg-new').hide();
} else if (boxTitle.includes('large')) {
  maxLimit = 11;
  // Hide the small box error
  $('.checkout--error-msg').hide();
}

let current = cart.item_count;

// Select proper error message container based on box type
let errorContainer = maxLimit === 7 ? $('.checkout--error-msg') : $('.checkout--error-msg-new');

// Logic for cart item limits
if (current > maxLimit) {
  let extra = current - maxLimit;
  $('button.cart__checkout-button.button').attr('disabled', 'disabled');
  $('a.button.custom_checkout-button').attr('disabled', 'disabled');
  errorContainer.find('.extra-items-1').text(extra);
 errorContainer.text(`Please remove ${extra} item(s).`).show();

} else if (current < maxLimit) {
  let remaining = maxLimit - current;
  $('button.cart__checkout-button.button').attr('disabled', 'disabled');
  $('a.button.custom_checkout-button').attr('disabled', 'disabled');
  errorContainer.find('.extra-items-1').text(remaining);
  errorContainer.text(`Add ${remaining} more item(s) to ${boxTitle.charAt(0).toUpperCase() + boxTitle.slice(1)}.`).show();
} else {
  // exactly at limit
  $('button.cart__checkout-button.button').removeAttr('disabled');
  $('a.button.custom_checkout-button').removeAttr('disabled');
  errorContainer.hide();
}
    });

  }

function refreshCartDrawer() {
  const cartDrawer = document.querySelector("cart-drawer");
  const drawerItems = document.querySelector("cart-drawer-items");

  // Fetch updated HTML directly from Shopify Section API to replace old drawer markup
  fetch(`${window.location.pathname}?sections=cart-drawer`)
    .then((response) => response.json())
    .then((parsedState) => {
      const updatedHtml = parsedState['cart-drawer'];
      const cleanDom = new DOMParser().parseFromString(updatedHtml, 'text/html');
      
      const newContent = cleanDom.querySelector('cart-drawer-items')?.innerHTML;
      const currentContentContainer = document.querySelector('cart-drawer-items');
      
      if (currentContentContainer && newContent) {
        currentContentContainer.innerHTML = newContent;
      }
      
      if (typeof drawerItems?.onCartUpdate === "function") {
        drawerItems.onCartUpdate();
      }
      
      if (cartDrawer && typeof cartDrawer.open === "function") {
        cartDrawer.open();
      }
    });
}

  function hideLoader() {
    $(".custom--subscription--loader-wrapper-packs").hide();
  }
});





  // $('body').on('click', 'button#bundle-cart-button', function () {
  //   var json_obj = [];

  //   function getCookie(name) {
  //     const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  //     return match ? decodeURIComponent(match[2]) : null;
  //   }

  //   var totalQty = 0;

  //   $('li.bundle--box--itesm-list').each(function () {
  //     var variantIdcart = parseInt($(this).attr('data-variant-id'));
  //     var variantQty = parseInt($(this).find('.product-item-count .count-number').text());
  //     var variantSellingid = parseInt($(this).attr('data-selling-id'));

  //     totalQty += variantQty;

  //     var item = {
  //       id: variantIdcart,
  //       quantity: variantQty,
  //       selling_plan: variantSellingid
  //     };

  //     json_obj.push(item);
  //   });

  //   var cookieVariantId = getCookie('selected_variant_id');

  //   // ✅ Add cookie item only if totalQty is 10 or more
  //   if (cookieVariantId && totalQty >= 10) {
  //     json_obj.push({
  //       id: parseInt(cookieVariantId, 10),
  //       quantity: 1,
  //       selling_plan: null
  //     });
  //   }

  //   $.ajax({
  //     type: "POST",
  //     url: "/cart/add.js",
  //     data: JSON.stringify({ items: json_obj }),
  //     dataType: "json",
  //     contentType: "application/json",
  //     success: function (data) {
  //       console.log('Cart updated:', data);
  //       $("cart-drawer-items").html($(data).find('cart-drawer-items').html());
  //       $("cart-drawer").addClass("active");
  //       refreshCartDrawer();

  //       $.getJSON('/cart.js', function (cart) {
  //         console.log(cart.item_count);
  //         $('.cart-count-bubble span[aria-hidden="true"]').text(cart.item_count);

  //         // ✅ Update progress bar
  //         const cookieVariantId = parseInt(getCookie('selected_variant_id'), 10);
  //         const itemCount = cart.items.reduce((total, item) => {
  //           if (item.variant_id !== cookieVariantId) {
  //             return total + item.quantity;
  //           }
  //           return total;
  //         }, 0);

  //         updateFreeGiftProgressBar(itemCount);
  //       });
  //     },
  //     error: function (xhr, status, error) {
  //       console.error('Error adding items to cart:', error);
  //     }
  //   });

  //   function refreshCartDrawer() {
  //     let cartDrawerItems = document.querySelector("cart-drawer-items");
  //     const cartDrawer = document.querySelector("cart-drawer");
  //     const cartDrawerCheckout = document.querySelector(".cart__checkout-button");

  //     if (cartDrawer) {
  //       cartDrawer.classList.remove("is-empty");
  //       cartDrawerCheckout?.removeAttribute("disabled");

  //       const emptyDrawerElement = cartDrawer.querySelector(".drawer__inner-empty");
  //       emptyDrawerElement?.remove();

  //       const cartContentsForm = document.querySelector(".cart__contents");
  //       if (cartContentsForm) {
  //         cartContentsForm.style.display = "block";
  //       }
  //     }

  //     if (!cartDrawerItems) {
  //       cartDrawerItems = document.createElement("cart-drawer-items");
  //       const drawerHeader = document.querySelector(".drawer__header");
  //       drawerHeader?.insertAdjacentElement("afterend", cartDrawerItems);
  //     }

  //     const cartItemsComponent = document.querySelector("cart-drawer-items");
  //     if (typeof cartItemsComponent?.onCartUpdate === "function") {
  //       cartItemsComponent.onCartUpdate();
  //     }

  //     if (typeof cartDrawer?.open === "function") {
  //       cartDrawer.open();
  //     }
  //   }
  // });

  // ✅ Progress Bar Update Function
function updateFreeGiftProgressBar(itemCount) {
    var barMessage = $('body').attr('data-bar-message');
    var successMessage = $('body').attr('data-sucess-message');

    const progressBarFill = document.querySelector(".free-gift-progress-bar-fill");
    const messageBox = document.querySelector(".free-gift-progress-message");

    if (!progressBarFill || !messageBox) return;

    const goal = 10;
    const percent = Math.min((itemCount / goal) * 100, 100);
    progressBarFill.style.width = `${percent}%`;

    if (itemCount >= goal) {
      messageBox.innerHTML = successMessage;
      progressBarFill.style.backgroundColor = "#28a745"; // Success Green
    } else {
      const remaining = goal - itemCount;
      let dynamicMessage = barMessage
        .replace('[[remaining]]', `<strong>${remaining}</strong>`)
        .replace('[[itemLabel]]', remaining > 1 ? 'items' : 'item');
      messageBox.innerHTML = dynamicMessage;
      progressBarFill.style.backgroundColor = "#28a745";
    }
  }




 
// $('body').on('click', 'button#bundle-cart-button', function () {

//   var json_obj = [];
// function getCookie(name) {
//     const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
//     return match ? decodeURIComponent(match[2]) : null;
//   }

//   var json_obj = [];



//   $('li.bundle--box--itesm-list').each(function () {
//     var variantIdcart = parseInt($(this).attr('data-variant-id'));
//     var variantQty = parseInt($(this).find('.product-item-count .count-number').text());
//     var variantSellingid = parseInt($(this).attr('data-selling-id'));

//     var item = {
//       id: variantIdcart,
//       quantity: variantQty,
//       selling_plan: variantSellingid // Shopify subscription plan ID
//     };

//     json_obj.push(item);
//   });
//   var cookieVariantId = getCookie('selected_variant_id');

//   if (cookieVariantId) {
//     json_obj.push({
//       id: parseInt(cookieVariantId, 10),
//       quantity: 1,
//       selling_plan: null
//     });
//   }

//   $.ajax({
//     type: "POST",
//     url: "/cart/add.js",
//     data: JSON.stringify({ items: json_obj }),
//     dataType: "json",
//     contentType: "application/json",
//     success: function (data) {
//       console.log('Cart updated:', data);
//        $("cart-drawer-items").html($(data).find('cart-drawer-items').html());
//       $("cart-drawer").addClass("active");
//       refreshCartDrawer();
//        $.getJSON('/cart.js', function(cart) {
//      console.log(cart.item_count)
//      $('.cart-count-bubble span[aria-hidden="true"]').text(cart.item_count);
//      });
//     },
//     error: function (xhr, status, error) {
//       console.error('Error adding items to cart:', error);
//     }
//   });
//     function refreshCartDrawer() {
//   let cartDrawerItems = document.querySelector("cart-drawer-items");
//   const cartDrawer = document.querySelector("cart-drawer");
//   const cartDrawerCheckout = document.querySelector(".cart__checkout-button"); // Ensure correct selector

//   if (cartDrawer) {
//     if (cartDrawer.classList.contains("is-empty")) {
//       cartDrawer.classList.remove("is-empty");
//     }
//       cartDrawerCheckout.removeAttribute("disabled");

//     const emptyDrawerElement = cartDrawer.querySelector(".drawer__inner-empty");
//     if (emptyDrawerElement) {
//       emptyDrawerElement.remove();
//     }

//     const cartContentsForm = document.querySelector(".cart__contents");
//     if (cartContentsForm) {
//       cartContentsForm.style.display = "block";
//     }
//   }

//   if (!cartDrawerItems) {
//     cartDrawerItems = document.createElement("cart-drawer-items");
//     const drawerHeader = document.querySelector(".drawer__header");
//     if (drawerHeader) {
//       drawerHeader.insertAdjacentElement("afterend", cartDrawerItems);
//     }
//   }

//   const cartItemsComponent = document.querySelector("cart-drawer-items");
//   if (cartItemsComponent && typeof cartItemsComponent.onCartUpdate === "function") {
//     cartItemsComponent.onCartUpdate();
//   }

//   if (cartDrawer && typeof cartDrawer.open === "function") {
//     cartDrawer.open();
//   }
  
// }    
// });


// cart product free chnage on act drawewr
$('body').on('click','li.your-product-first-item',function () {
    $('li.your-product-first-items').toggle();
})



// quick view code
$('body').on('click','.svg--zoom-icon',function () {
   $('.quick-view-product-wrapper').hide();
    $('body').addClass('zoom-in-active');
    $(this).parents('.bundle-product').find('.quick-view-product-wrapper').show();
})
$('body').on('click','.quick-view-product-wrapper span.svg-wrapper svg.icon.icon-close,.quick-view-product-wrapper button.bundle-add-btn-quick-view',function () {
    $('body').removeClass('zoom-in-active');
    $('.quick-view-product-wrapper').hide();
})
$('body').on('click','button.bundle-add-btn-quick-view',function () {
    //$(this).hide();
if ($(this).parents('.bundle-product').find('.bundle--qty-box').is(':visible')) {
  $(this).parents('.bundle-product').find('button.quanityt--box.qty-plus').trigger('click');
} else {
   $(this).parents('.bundle-product').find('button.bundle-add-btn').trigger('click');
}
 
})

$('body').on('click','.quick-view-product-wrapper button.quanityt--box-qty-minus',function () {
    $(this).parents('.bundle-product').find('button.quanityt--box.qty-minus').trigger('click');
    var Parentqtyminus =  parseInt($(this).parents('.bundle-product').find('input.qty-input').val());
     $(this).parents('.bundle-product').find('.quick-view-product-wrapper input.qty-input').val(Parentqtyminus);
    if(Parentqtyminus == 0){
        $(this).parents('.quick-view-product-wrapper').find('.bundle--qty-box-quick-view').hide();
         $(this).parents('.quick-view-product-wrapper').find('button.bundle-add-btn-quick-view').show();
    }
})
$(document).on('click', function (e) {
  if ($('body').hasClass('zoom-in-active')) {
    if (
      !$(e.target).closest('.quick-view-product-wrapper-iner').length &&
      !$(e.target).closest('.svg--zoom-icon').length
    ) {
      $('.quick-view-product-wrapper').hide();
      $('body').removeClass('zoom-in-active');
    }
  }
});
function getCookie(name) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? decodeURIComponent(match[2]) : null;
}

$(document).ready(function () {
  const freeOfferVariantId = parseInt(getCookie("selected_variant_id"));

  $.getJSON("/cart.js").done(function (cart) {
      var totalPrice = cart.total_price;
  var totalPriceFormatted = (totalPrice / 100).toFixed(2);
$('.totals__total-value-cart').text('$'+totalPriceFormatted+' USD')
    let totalCount = 0;
    let cartTotal = 0;

    cart.items.forEach(function (item) {
      if (item.variant_id === freeOfferVariantId) {
        return; // skip free offer
      }

      totalCount += item.quantity;
      cartTotal += (item.price * item.quantity);
    });
    
    // Convert cartTotal from cents to dollars
    cartTotal = cartTotal / 100;
    
if ($('body').hasClass('product')) {
    // Enable checkout if either condition is met:
    // 1. At least 5 items, OR
    // 2. Cart total is more than $90
    if (totalCount >= 5 || cartTotal > 90) {
      $('button#CartDrawer-Checkout').removeAttr('disabled');
      $('button#checkout').removeAttr('disabled');
    } else {
      $('button#CartDrawer-Checkout').attr('disabled', 'disabled');
       $('button#checkout').attr('disabled','disabled');
    }
// Get the box type from title text
let boxTitle = $('.subscription-box-header .subscription-box-title').text().trim(); // small / large
let maxLimit = 0;

if (boxTitle.includes('signature') || boxTitle.includes('small')) {
  maxLimit = 7;
  // Hide the large box error
  $('.checkout--error-msg-new').hide();
} else if (boxTitle.includes('large')) {
  maxLimit = 11;
  // Hide the small box error
  $('.checkout--error-msg').hide();
}

let current = cart.item_count;

// Select proper error message container based on box type
let errorContainer = maxLimit === 7 ? $('.checkout--error-msg') : $('.checkout--error-msg-new');

// Logic for cart item limits
if (current > maxLimit) {
  let extra = current - maxLimit;
  $('button.cart__checkout-button.button').attr('disabled', 'disabled');
  $('a.button.custom_checkout-button').attr('disabled', 'disabled');
  errorContainer.find('.extra-items-1').text(extra);
  errorContainer.text(`Please remove ${extra} item(s).`).show();

} else if (current < maxLimit) {
  let remaining = maxLimit - current;
  $('button.cart__checkout-button.button').attr('disabled', 'disabled');
  $('a.button.custom_checkout-button').attr('disabled', 'disabled');
  errorContainer.find('.extra-items-1').text(remaining);
  errorContainer.text(`Add ${remaining} more item(s) to ${boxTitle.charAt(0).toUpperCase() + boxTitle.slice(1)}.`).show();
} else {
  // exactly at limit
  $('button.cart__checkout-button.button').removeAttr('disabled');
  $('a.button.custom_checkout-button').removeAttr('disabled');
  errorContainer.hide();
}




  }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  $.getJSON("/cart.js").done(function (cart) {
    const itemCount = cart.items.reduce((total, item) => {
      const freeProductId = parseInt(getCookie("selected_variant_id"), 10);
      if (item.variant_id !== freeProductId) {
        return total + item.quantity;
      }
      return total;
    }, 0);

    updateFreeGiftProgressBar(itemCount);
  });

  function getCookie(name) {
    const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
    return match ? decodeURIComponent(match[2]) : null;
  }

  function updateFreeGiftProgressBar(itemCount) {
    var barMessage = $('body').attr('data-bar-message');
    var successMessage = $('body').attr('data-sucess-message');

    const progressBarFill = document.querySelector(".free-gift-progress-bar-fill");
    const messageBox = document.querySelector(".free-gift-progress-message");

    if (!progressBarFill || !messageBox) return;

    const goal = 10;
    const percent = Math.min((itemCount / goal) * 100, 100);
    progressBarFill.style.width = `${percent}%`;

    if (itemCount >= goal) {
      messageBox.innerHTML = successMessage;
      progressBarFill.style.backgroundColor = "#28a745"; // Success Green
    } else {
      const remaining = goal - itemCount;
      let dynamicMessage = barMessage
        .replace('[[remaining]]', `<strong>${remaining}</strong>`)
        .replace('[[itemLabel]]', remaining > 1 ? 'items' : 'item');
      messageBox.innerHTML = dynamicMessage;
      progressBarFill.style.backgroundColor = "#28a745";
    }
  }
});




// cart subscription poup
$(window).on('load', function () {
 // if ($('body').hasClass('products--subscription')) {

    var urlParams = new URLSearchParams(window.location.search);

    if (urlParams.has('frequency')) {
      var frequencyValue = urlParams.get('frequency');

      if (frequencyValue === 'one-time') {
        
        // Show custom checkout button
        $('button.button.custom_checkout-button').show();
        $('button#CartDrawer-Checkout').hide();
        $('a.button.custom_checkout-button').css('display','inline-flex');
      $('.cart__checkout-button').hide();
      } else {
         
        // Show default checkout button
        $('button#CartDrawer-Checkout').show();
        $('button.button.custom_checkout-button').hide();
         $('a.button.custom_checkout-button').hide();
      $('.cart__checkout-button').show();
      }

    } else {
      $('button#CartDrawer-Checkout').show();
        $('button.button.custom_checkout-button').hide();
         $('a.button.custom_checkout-button').hide();
      $('.cart__checkout-button').show();
    }
 // }
});

// $('body').on('click','button.button.custom_checkout-button',function () {
//   $('body').addClass('is--cart-popup-active');
//  $('.cart--darwer--subscription-popup').show();
// })






// updte the subscription
$('.popup-continue').on('click', function(){
  var selectedPlanName = $('form#subscriptionForm input[type="radio"]:checked')
    .closest('label')
    .find('span.plan-label')
    .attr('data-palan--name');

  $('.custom--subscription--loader-wrapper').show();
  console.log("👉 Selected Plan Name:", selectedPlanName);

  $.getJSON('/cart.js', async function(cart){
    let items = cart.items;
    
    // We loop through the items sequentially using modern async/await
    for (let i = 0; i < items.length; i++) {
      let item = items[i];
      let variantId = item.variant_id;
      let matchingLi = $('li[data-palan--name="' + selectedPlanName + '"][data-variant-id="' + variantId + '"]');
      
      if (matchingLi.length) {
        let sellingId = matchingLi.data('selling-id');
        console.log("🔄 Syncing Line Item:", item.title, "→ Plan:", sellingId);

        try {
          // Await completion so Shopify updates sequentially
          await $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            dataType: 'json',
            contentType: 'application/json',
            data: JSON.stringify({
              id: item.key,            
              quantity: item.quantity, 
              selling_plan: sellingId  
            })
          });
        } catch (err) {
          console.error("❌ Line item update failed:", err);
        }
      }
    }

    alert("🎉 All bundle subscription tiers updated on server.");
    
    // FETCH FRESH CART AND FORCE WEB COMPONENTS TO RE-RENDER
    $.getJSON('/cart.js', function(freshCart) {
      // 1. Hide popup wrappers
      $('#subscriptionPopupcartdrawer').fadeOut();
      $('body').removeClass('is--cart-popup-active');
      $('.cart--darwer--subscription-popup').hide();
      $('.custom--subscription--loader-wrapper').hide();

      // 2. Announce update to theme section engines (Dawn / Standard architectures)
      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: { cart: freshCart }
      }));

      // 3. Trigger your theme's specific custom renderer hooks
      const cartDrawer = document.querySelector("cart-drawer");
      const drawerItems = document.querySelector("cart-drawer-items");
      
      if (drawerItems && typeof drawerItems.onCartUpdate === "function") {
        drawerItems.onCartUpdate();
      } else if (typeof refreshCartDrawer === "function") {
        refreshCartDrawer();
      }

      if (cartDrawer && typeof cartDrawer.open === "function") {
        cartDrawer.open();
      }
    });
  });
});









$('body').on('click','form#subscriptionForm label',function () {
    var getDiscountVal = $(this).attr('data-discount');
    $('.popup--button-save-option.option---1 span.save-text').text('Save ' +getDiscountVal +'%')
    // $('span.save-text--new').text(getDiscountVal +'%')
}) 


// first step product add to cart
$('body').on('click', '.choose-you-plan-box', function () {
  var newVariantId = parseInt($(this).attr('data-variant-id'), 10);
  var targetProductId = 10030172111167; // Free offer product id
  console.log("Clicked variant:", newVariantId);

  $.getJSON('/cart.js', function (cart) {
    var existingFreeOfferVariantId = null;

    // Cart में target product है तो उसका variant पकड़ लो
    cart.items.forEach(function (item) {
      if (item.product_id == targetProductId) {
        existingFreeOfferVariantId = item.variant_id;
      }
    });

    if (existingFreeOfferVariantId) {
      // पुराना free offer हटाओ
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: {
          id: existingFreeOfferVariantId,
          quantity: 0
        },
        dataType: 'json',
        success: function () {
          console.log("🗑️ Old free offer removed:", existingFreeOfferVariantId);
          // अब नया add करो
          addNewOffer(newVariantId);
        }
      });
    } else {
      // अगर नहीं है तो direct नया add करो
      addNewOffer(newVariantId);
    }
  });

  // नया free offer add करने का function
  function addNewOffer(variantId) {
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        id: variantId,
        quantity: 1
      },
      dataType: 'json',
      success: function (item) {
        console.log("✅ New free offer added:", variantId);
        
      }
    });
  }
});





$('body').on('click','li.chnage--cuts-option',function () {
    $('cart-drawer').removeClass('active');
    $('body').removeClass('overflow-hidden');
})

// cart item eith quntiy
function syncCartWithBundleProducts() {
    $.getJSON('/cart.js', function(cart) {
        cart.items.forEach(function(item) {
            var variantId = item.variant_id;   // Shopify variant id
            var quantity  = item.quantity;     // Shopify quantity

            // Ab us variant-id ka product card lo
            var $card = $('.bundle-product[data-variant-id="'+variantId+'"]');

            if ($card.length) {
                console.log("Cart match:", variantId, "Qty:", quantity);

                // 1. pehle add-btn trigger karo (logic chale)
                $card.find('button.bundle-add-btn').trigger('click');

                // 2. Agar quantity > 1 hai, to plus button utni bar click karvao
                if (quantity > 1) {
                    let $plusBtn = $card.find('.qty-plus');

                    // chhota delay taaki add-btn ka logic complete ho jaye
                    setTimeout(function() {
                        for (let i = 1; i < quantity; i++) { 
                            $plusBtn.trigger('click');
                        }
                    }, 300);
                }
            }
        });
    });
}

// ---------- On page load run ----------
$(document).ready(function () {
    syncCartWithBundleProducts();
});

// ---------- Click par bhi run ----------
$('body').on('click','li.chnage--cuts-option',function () {
    $('cart-drawer').removeClass('active');
    $('body').removeClass('overflow-hidden');

    syncCartWithBundleProducts();
});



$('body').on('click', 'li.your-product-first-items', function () {
  $('body').addClass('free-product-adding');
  var newVariantId = $(this).data('var-id');
  var targetProductId = 10030172111167; // Free offer ka product id
  $('li.your-product-first-items').hide();

  // Step 1: Get current cart
  $.getJSON('/cart.js', function (cart) {
    var existingFreeOfferItem = null;

    // Check if specific product already in cart
    cart.items.forEach(function (item) {
      if (item.product_id == targetProductId) {
        existingFreeOfferItem = item; // poora object lelo
      }
    });

    // Step 2: Agar product hai to pehle remove karo
    if (existingFreeOfferItem) {
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: {
          id: existingFreeOfferItem.variant_id,
          quantity: 0
        },
        dataType: 'json',
        success: function () {
          refreshCartDrawer();
          addFreeOffer(newVariantId);
        }
      });
    } else {
      // Agar product cart me nahi hai to direct add karo
      addFreeOffer(newVariantId);
    }
  });
});

// Step 3: Add clicked variant + selling_plan assign
function addFreeOffer(variantId) {
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      id: variantId,
      quantity: 1
    },
    dataType: 'json',
    success: function (item) {
      refreshCartDrawer();

      var productTitle = item.product_title;   // Product ka main title
      var variantTitle = item.variant_title;   // Variant ka naam
      var productImage = item.image;

      $('.cart-drawer__offer-item.offer-item .offer-image img').attr('src', productImage);
      $('.cart-drawer__offer-item.offer-item p.offer-variant-name').text(productTitle + ' - ' + variantTitle);
      $('.announcement-inner.choose-free-ofefr span.itme--dynamic').text(variantTitle)
      $('body').removeClass('free-product-adding');

      // ✅ Step 4: Selling Plan Handling
      var urlParams = new URLSearchParams(window.location.search);
      var frequencyVal = urlParams.get("frequency");
      console.log("🔍 Frequency from URL:", frequencyVal);

      var newSellingPlanId = "";
      if (frequencyVal) {
        $("ul.offer-subscription-plans li").each(function () {
          var planName = $(this).data("plan-name");
          if (planName && planName.toString().toLowerCase() === frequencyVal.toString().toLowerCase()) {
            newSellingPlanId = $(this).data("selling-plan-id");
          }
        });
      }
      console.log("📦 New Selling Plan ID:", newSellingPlanId);

      // Step 5: Update selling_plan agar mila
      if (newSellingPlanId) {
        $.getJSON("/cart.js").done(function (cart) {
          var freeOfferItem = cart.items.find(function (i) {
            return i.product_id == 10030172111167;
          });

          if (freeOfferItem) {
            $.ajax({
              type: "POST",
              url: "/cart/change.js",
              data: JSON.stringify({
                id: String(freeOfferItem.key), // ✅ use line_item key
                quantity: freeOfferItem.quantity,
                selling_plan: newSellingPlanId,
                properties: freeOfferItem.properties || {}
              }),
              dataType: "json",
              contentType: "application/json",
              success: function (data) {
                console.log("✅ Free offer selling plan updated:", newSellingPlanId);
                   refreshCartDrawer();
              },
              error: function (xhr, status, error) {
                console.error("❌ Error updating free offer selling plan:", error, xhr.responseText);
              }
            });
          }
        });
      }
    }
  });
}

(function() {
    var lastScrollTop = 0;

    window.addEventListener('scroll', function() {
        var st = window.pageYOffset || document.documentElement.scrollTop;

        if (st < lastScrollTop) {
            document.body.classList.add('scroll-up-active');
        } else {
            document.body.classList.remove('scroll-up-active');
        }

        lastScrollTop = st <= 0 ? 0 : st;
    });
})();